import { RotateCcw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { PredictiveSuburbManager } from "./predictive-suburb-manager";

export const CallCounter = (predictiveManager: PredictiveSuburbManager) => {
  return (
    <div>
      <CardContent>
        <div className="flex items-center justify-center gap-4">
          <p>{`Call counter: ${predictiveManager.callCounter}`}</p>
          <p>
            {`Credit counter: ${predictiveManager.creditCounter.toLocaleString(
              "en-US",
              { minimumFractionDigits: 1 },
            )}`}
          </p>
          <Button
            variant="ghost"
            size="icon"
            onClick={() => {
              predictiveManager.setCallCounter(0);
              predictiveManager.setCreditCounter(0);
            }}
          >
            <RotateCcw className="size-4" />
          </Button>
        </div>
      </CardContent>
    </div>
  );
};
